import moment from "moment"
import _ from 'lodash'


/**
 * 时间格式化
 */
export let dateFilter = (time, type) => {
  // type = type || 'YYYY-MM-DD'
  // time ? time = time.replace(/-/g, "/") : ''
  // return time ? moment(new Date(time)).format(type) : "";
  return time;
}

export let timeFilter = (time, type) => {
  type = type || 'YYYY-MM-DD'
  return time ? moment(new Date(time)).format(type) : "";
}



export let timeStrFilter = (time) => {
  if (time == 2400) {
    return '无期徒刑及以上刑罚'
  } else if (time && time > 12) {
    let month = parseInt(time.toFixed(0) % 12);
    let year = parseInt(time.toFixed(0) / 12);
    return year.toFixed(0) + '年' + (month ? month.toFixed(0) + '个月' : '')
  } else if (time > 0 && time < 13) {
    if (time.toFixed && time.toFixed(0) == 12) {
      return '1年'
    } else {
      return time.toFixed && time.toFixed(0) + '个月'
    }

  } else {
    return time
  }
}

export let phoneFilter = (num) => {
  var str = "****";
  var number = "";
  if (!num) {
    return number;
  } else {
    number = num.slice(0, 3) + str + num.slice(7);
    return number;
  }
}

export let highlight = (value, keyword, style) => {
  try {
    let replaceValue = ''
    let noMatchAll = false;

    if (value && keyword) {
      value = value.replace(/<\/?[^>]*>/g, '');
      var reg;
      if (Array.isArray(keyword)) {
        if (keyword.length > 0) {
          reg = new RegExp('(' + keyword.join('|') + ')', 'g')
        } else {
          noMatchAll = true;
        }
      } else if (keyword.length > 0 && keyword.length <= 20) {
        const keywordArr = keyword.match(/[\u4e00-\u9fa5]/g);
        reg = new RegExp('(' + keywordArr.join('|') + ')', 'g');
      } else {
        reg = new RegExp('(' + keyword + ')', 'g')
      }
      
      if (!noMatchAll) {
        for (var i = 0; i < keyword.length; i++) {
          if (keyword[i].trim().length > 0 && value.indexOf(keyword[i]) == -1) {
            noMatchAll = true;
          }
        }
      }
      if (noMatchAll || keyword.length == 0) {
        return value
      } else {
        if (style) {
          replaceValue = value.replace(reg, style)
        } else {
          replaceValue = value.replace(reg, '<font color = "#F86359">$1</font>')
        }
        
        return replaceValue
      }
  
    } else {
      return value;
    }
  } catch (err) {
    console.error(err);
    return value;
  }
}


export let setHighlight = (text, list) => {
  if (list && list.length > 0) {
    var reg = new RegExp('(' + list.join('|') + ')', 'g')
    text = text && text.replace(reg, '<font color = "#F86359">$1</font>')
  }
  return text;
}

export let sliceStr = (str, len) => {
  len ? '' : len = 120
  if (str) {
    str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
    str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
    str = str.replace("editor-content'>", '');
    str = str.replace('"text-align:justify;">', '');
    str = str.replace(/\n[\s| | ]*\r/g, '\n'); //去除多余空行
    str = str.replace(/&nbsp;/ig, '').trim(); //去掉&nbsp
    if (str.length > len) {
      return str.substring(0, len) + '...'
    } else {
      return str;
    }
  } else {
    return str;
  }
}

export let removeSpace = (str, key) => {
  if (str) {
    // str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
    str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
    str = str.replace(/\n[\s| | ]*\r/g, '\n'); //去除多余空行
    str = str.replace(/&nbsp;/ig, '').trim(); //去掉&nbsp
    if (key) {
      // key = key.replace(/<\/?[^>]*>/g, '');
      key = key.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
      key = key.replace(/\n[\s| | ]*\r/g, '\n'); //去除多余空行
      key = key.replace(/&nbsp;/ig, '').trim(); //去掉&nbsp
      var list = key.split(/\【(.+?)\】/);
      list.forEach((v, i) => {
        if (v) {
          if (i == 1) {
            str = str.replace("【" + v + "】", '')
          } else {
            str = str.replace(v, '')
          }
        }
      })
    }
    return str
  }
}

export let sliceArrayStr = (arr, type, key) => {
  var obj = _.groupBy(arr, type)
  var string = ''
  if (key && obj && obj[key]) {
    obj[key].forEach(v => {
      if (v.text) {
        string += v.text;
      } else {
        string += v.paragraphText;
      }

    })

    if (string && string.length > 120) {
      string = string.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
      string = string.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
      string = string.replace(/\n[\s| | ]*\r/g, '\n'); //去除多余空行
      string = string.replace(/&nbsp;/ig, '').trim(); //去掉&nbsp
      return string.substring(0, 120) + '...'
    } else {
      return string;
    }

  }
}

export let enterLine = (value) => {
  if (value) {
    return value.replace(/\n/g, "<div>");
    // return value.replace(/<br>/gi, "");
  } else {
    return ''
  }
}

export let moneyFilter = (s, n) => {
  if (s == 0) return 0;
  if (!s) return "";
  n = n > 0 && n <= 20 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  let l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
  let t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
  }

  return (t.split("").reverse().join("") + "." + r).replace(/\.00$/, '');
}

export let macthBookLevel = (str) => {
  if (str) {
    let firstLevel = new RegExp('第[一|二|三|四|五|六|七|八|九|十].*?编', 'g')
    let secondLevel = new RegExp('第[一|二|三|四|五|六|七|八|九|十].*?章', 'g')
    let thirdLevel = new RegExp('第[一|二|三|四|五|六|七|八|九|十].*?节', 'g')
    let lastLevel = new RegExp('第[一|二|三|四|五|六|七|八|九|十].*?条', 'g')
    if (firstLevel.test(str)) {
      return '编'
    }

    if (secondLevel.test(str)) {
      return '章'
    }

    if (thirdLevel.test(str)) {
      return '节'
    }

    if (lastLevel.test(str)) {
      return '条'
    }
  } else {
    return ''
  }

}

const formatSpecialRegSymbol = (text) => {
  if (!text) {
    return '';
  }

  const specialSymbolStr = ['[', ']', '\\', '^', '$', '.', '|', '?', '*', '+', '(', ')']
    .map(s => `\\${s}`)
    .join('|');
    return text.replace(new RegExp(specialSymbolStr, 'g'), s => `\\${s}`);
}

export let highlightLabel = (value, keyword, c) => {
    let replaceValue = ''
    let colors = ['#F86359']
    if (keyword && keyword.length > 0 && value) {
      let params = []
      for (let i = 0; i < keyword.length; i++) {
        let color = colors[0]
        keyword[i].stories.forEach(x => {
          var model = {
            content: formatSpecialRegSymbol(x.content && x.content.replace(/[\ |\(|\)]/g, "")),
            opponent: formatSpecialRegSymbol(keyword[i].name),
            color: color
          }
          params.push(model)
        })
      }
      let replaceValue = value;
      params.forEach(v => {
        if (v.content) {
          try {
            let reg = new RegExp('(' + v.content + ')', 'g')
            replaceValue = replaceValue.replace(reg, `<font color = ${v.color}>$1</font>`)
          } catch (err) {
            replaceValue = replaceValue;
          }

          let opponentReg = v.opponent;
          try {
            opponentReg = new RegExp('(' + v.opponent + ')', 'g')
          } catch (err) {
            console.error(err);
          }
          if (opponentReg) {
            replaceValue = replaceValue.replace(opponentReg, `<font color = ${v.color}>$1</font>`)
          }
        }
      })
      if (params.length > 0) {
        return replaceValue
      } else {
        return value
      }

    } else {
      return value
    }
  }
  // #F86359


// WEBPACK FOOTER //
// ./src/filter.js